import '../application/javascripts/index.js.erb';
import $ from "jquery";
import hyperform from "hyperform";
import "bootstrap-datepicker/dist/locales/bootstrap-datepicker.fr-CH.min"

$.when($.ready).then(function () {
    hyperform.addTranslation("fr",{
        TextTooLong:"Veuillez raccourcir ce champ à %l caractères ou moins (vous utilisez actuellement %l caractères).",
        TextTooShort:"Veuillez utiliser au moins %l caractères pour ce champ (vous utilisez actuellement %l caractères).",
        ValueMissing:"Veuillez compléter ce champ.",
        CheckboxMissing:"Veuillez cocher cette case si vous désirez poursuivre.",
        RadioMissing:"Veuillez sélectionner l'une de ces options.",
        FileMissing:"Veuillez sélectionner un fichier.",
        SelectMissing:"Veuillez sélectionner un élément de la liste.",
        InvalidEmail:"Veuillez saisir une adresse électronique valide.",
        InvalidURL:"Veuillez saisir une URL.",
        PatternMismatch:"Veuillez modifier la valeur pour correspondre au format demandé.",
        PatternMismatchWithTitle:"Veuillez modifier la valeur du champ pour correspondre au format demandé : %l.",
        NumberRangeOverflow:"Veuillez sélectionner une valeur inférieure ou égale à %l.",
        DateRangeOverflow:"Veuillez sélectionner une valeur antérieure ou égale à %l.",
        TimeRangeOverflow:"Veuillez sélectionner une valeur antérieure ou égale à %l.",
        NumberRangeUnderflow:"Veuillez sélectionner une valeur supérieure ou égale à %l.",
        DateRangeUnderflow:"Veuillez sélectionner une valeur postérieure ou égale à %l.",
        TimeRangeUnderflow:"Veuillez sélectionner une valeur postérieure ou égale à %l.",
        StepMismatch:"Veuillez sélectionner une valeur valide. Les deux valeurs valides les plus proches sont %l et %l.",
        StepMismatchOneValue:"Veuillez sélectionner une valeur valide. La valeur valide la plus proche est %l.",
        BadInputNumber:"Veuillez saisir un nombre.",
    });
    hyperform.setLanguage("fr");
    hyperform(window);
    
    window.MutiselectOptions =  {
        enableClickableOptGroups: true,
        maxHeight: 350,
        buttonWidth: '100%',
        buttonClass: 'multiselect dropdown-toggle btn btn-primary btn-left',
        selectAllText: 'Sélectionner tout',
        filterPlaceholder: 'Chercher',
        nonSelectedText: 'Aucun sélectionné',
        nSelectedText: 'selectionné',
        allSelectedText: 'Tout sélectionner',
        enableFiltering: true
    };

    $('#mobile-nav').hcOffcanvasNav({
        maxWidth: false,
        levelTitles: true,
        pushContent: false,
        closeLevels: true,
        position: 'right',
        customToggle: $('.toggle'),
        labelClose: 'Fermer',
        labelBack: 'Retour'
    });
    
});
